import React from "react";

export const ModalContext = React.createContext<string | null | undefined>(
    null,
);
